import { IconType } from "react-icons";
import styled from "styled-components";

const Container = styled("div")`
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #14141456;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 4;
`;

interface IFocusedFullscreenButton {
  handleClick: () => void;
  Icon: IconType;
}

const FocusedFullscreenButton = ({
  handleClick,
  Icon,
}: IFocusedFullscreenButton) => {
  return (
    <Container id="focused-fullscreen" onClick={handleClick}>
      <Icon size={25} fill="white" />
    </Container>
  );
};

export default FocusedFullscreenButton;
